import React, { useState } from 'react'
import { Button, Tooltip } from 'reactstrap'

export default function ExcelButton({
  id = 'export-to-excel',
  label,
  disabled,
  onClick = () => {},
  enableTooltip = false,
  style = {},
}) {
  const [displayTooltip, setDisplayTooltip] = useState(false)

  const toggleDisplayTooltip = () => {
    if (enableTooltip) {
      setDisplayTooltip((prev) => !prev)
    }
  }

  return (
    <>
      <Button
        disabled={disabled}
        id={id}
        size='sm'
        className='btn btn-gold'
        style={style}
        onMouseEnter={() => enableTooltip && setDisplayTooltip(true)}
        onMouseLeave={() => enableTooltip && setDisplayTooltip(false)}
        onClick={onClick}
      >
        <i class='far fa-file-excel' />
      </Button>

      <Tooltip placement='top' isOpen={displayTooltip} target={id} toggle={toggleDisplayTooltip}>
        {label}
      </Tooltip>
    </>
  )
}
